export default "__VITE_ASSET__02aa5442__"